import React, { useContext } from 'react';
import { useDeleteRoleMutation } from '../../../services/SkillsManagement';
import { useDispatch } from 'react-redux';
import { DELETE_ROLE } from '../../../Reducers/Actions';
import { SnackBarContext } from '../../../Context/SnackBarContextProvider';
import DeleteIcon from '@mui/icons-material/Delete';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import MuiDialog from '../../../SystemDesign/MuiDialog';

const DeleteRole = ({ row }) => {
    const [deleteRole] = useDeleteRoleMutation();
    const dispatch = useDispatch();
    const { setInfoAlert, setOpenSnackBar } = useContext(SnackBarContext);

    const handleDelete = async () => {
        try {
            await deleteRole({ roleId: row.original.roleId }).unwrap();
            dispatch({ type: DELETE_ROLE, roleId: row.original.roleId });
            setInfoAlert({ severity: 'success', message: `Role ${row.original.name} deleted successfully` });
            setOpenSnackBar(true);
        } catch (error) {
            setInfoAlert({ severity: 'error', message: error.data?.message || 'An error occurred while deleting the role' });
            setOpenSnackBar(true);
        }
    };

    const triggerButton = (
        <MenuItem>
            <ListItemIcon>
                <DeleteIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Delete</ListItemText>
        </MenuItem>
    );

    const dialogContent = (
        <div>
            <p>Are you sure you want to delete this role?</p>
            <p>This action is irreversible.</p>
        </div>
    );

    return (
        <MuiDialog
            icon={<DeleteIcon />}
            triggerButton={triggerButton}
            title="Delete role"
            subtitle={`You are about to delete ${row.original.name}`}
            content={dialogContent}
            existAction={true}
            actionTitle="Delete"
            actionFunction={handleDelete}
        />
    );
};

export default DeleteRole;
